import { AppLayout } from "../../components/layout/Header";
import SignInPanel from "../../components/auth/SignInPanel";

export default function Login() {
  return (
    <AppLayout>
      <SignInPanel />
    </AppLayout>
  );
}
